export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70b9582f9e37edbc5adbbc2194dc2d35792f50bd0f&name=pushAdClickData!'